import React from "react";
import { PAYMENT_METHOD_SERVICES } from "utils/constants/payment";
import { styles } from "./styles";
import Visa from "./Visa";
import Mastercard from "./Mastercard";
import Amex from "./Amex";
import Discover from "./Discover";
import JCB from "./JCB";

const DEFAULT_CLASSES = {
  list: "list ma0 pa0 flex flex-wrap",
  item: "flex paymentMethod__container bg-white relative mv2"
};

export const PaymentMethodServiceLogoGrid = ({ services, customClasses }) => {
  const classes = { ...DEFAULT_CLASSES, ...customClasses };
  const nodes = services.map((service, iconIx) => (
    <li className={classes.item} key={iconIx}>
      <div className={`image__cover--after paymentMethod--${service}`}></div>
    </li>
  ));

  return <ul className={classes.list}>{nodes}</ul>;
};

const AcceptedPaymentMethods = () => {
  return (
    <div className="w-100 db">
      <div className="f6 fw6 pb2 mb1">Supported payment methods</div>
      <div className="f7 black-60 pb2">Cards</div>
      <ul className="list w-100 ma0 pa0 flex flex-wrap">
        {[<Visa />, <Mastercard />, <Amex />, <Discover />, <JCB />].map(
          (node, nodeIx) => (
            <li className="pa1" key={nodeIx}>
              {node}
            </li>
          )
        )}
      </ul>
      <div className="f7 black-60 pt2">Wallets</div>
      <PaymentMethodServiceLogoGrid
        services={Object.values(PAYMENT_METHOD_SERVICES)}
      />
      <div className="f7 black-60 pv2">+ more</div>
      <style jsx>{styles}</style>
    </div>
  );
};

export default AcceptedPaymentMethods;
